// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wm6bm","delete":"styles_delete__1adsB","update":"styles_update__zPz9h","add":"styles_add__1Jrem"};